import '@/setup/axios'
import '@/setup/vue'
import '@/setup/lodash'
import { apolloProvider } from '@/setup/apollo'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store'

Vue.config.productionTip = false

// import 'bulma/css/bulma.css'
// import 'vue-multiselect/dist/vue-multiselect.min.css'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  apolloProvider,
  render: h => h(App),
})



// WEBPACK FOOTER //
// ./src/main.js